import * as React from 'react';
import { useQuery, QueryHookOptions } from '@apollo/react-hooks';

import { message } from 'antd';

import { GET_CLIENTS_QUERY } from '@frontend/app/queries';
import { GetClientsQuery } from '@frontend/app/queries/types/GetClientsQuery';

const { useEffect } = React;
type IOptions = QueryHookOptions<GetClientsQuery>;

export function useGetClients(options: IOptions = {}) {
  const {
    loading,
    data: { clients = [] } = {},
    error,
    refetch,
  } = useQuery<GetClientsQuery>(GET_CLIENTS_QUERY, options);

  useEffect(() => {
    if (error) {
      message.error(error.message);
    }
  }, [error]);

  return {
    loading,
    clients,
    error,
    refetch,
  };
}
